module.exports = __webpack_public_path__ + "static/media/gocompare.ecaf06a7.svg";